// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class ContactPersonDto {
    @AutoMap() address: string;
    @AutoMap() city: string;
    @AutoMap() countryId: string;
    @AutoMap() email: string;
    @AutoMap() firstName: string;
    @AutoMap() maidenName: string;
    @AutoMap() genderId: number;
    @AutoMap() lastName: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() relationshipId: string;
    @AutoMap() remarks: string;

    public constructor(init?: Partial<ContactPersonDto>) {
        Object.assign(this, init);
    }
}
